import "./whitepaper.css";
import whitepaper_img from "../../../assets/images/whitepaper/whitepaper.png";
import tokenomics_img from "../../../assets/images/whitepaper/tokenomics.png";

const WhitepaperSection = () => {
  return (
    <div
      className="section text-start d-flex align-items-center"
      id="whitepaper"
    >
      <div className="container">
        <div className="whitepaper-title text-center">
          <h5>Rexla Guide</h5>
          <h1>Whitepaper & Tokenomics</h1>
        </div>

        <div className="row">
          <div className="col-md-6 whitepaper-left">
            <a href="./docs/Whitepaper.pdf" target="_blank" className="img-btn">
              <img
                className="img-fluid"
                src={whitepaper_img}
                alt="whitepaper"
              />
            </a>

            <h2 className="text-white mt-3">Whitepaper</h2>
            <p>
              Then Whitepaper outlines our vision, technology, and ecosystem,
              providing a comprehensive roadmap for the future of Rexla.
            </p>

            <a
              type="button"
              className="btn btn-light"
              href="./docs/Whitepaper.pdf"
              target="_blank"
            >
              Learn More
            </a>
          </div>
          <div className="col-md-6 tokenomics-right">
            <a
              href="./docs/Economic_paper.pdf"
              target="_blank"
              className="img-btn"
            >
              <img
                className="img-fluid"
                src={tokenomics_img}
                alt="tokenomics"
              />
            </a>
            <h2 className="text-white mt-3">Tokenomics</h2>
            <p>
              The Rexla Economics Paper details the RXG tokenomics, utility, and
              mechanisms driving value creation whthin the Rexla ecosystem.
            </p>

            <a
              type="button"
              className="btn btn-light"
              href="./docs/Economic_paper.pdf"
              target="_blank"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhitepaperSection;
